import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus, faTimes, faEllipsisV, faBars, faMinusCircle, faSpinner, faExclamationTriangle, faSync, faPlay, faCheck, faPause, faEdit, faCaretUp, faCaretDown } from '@fortawesome/free-solid-svg-icons'
import Buefy from '@ntohq/buefy-next'

import { ToggleButton } from './vendor/vue-js-toggle-button'
import VueSimpleAlert from './vendor/vue3-simple-alert/lib'

import config from './../app.config.json'
import App from './App.vue'
import routes from './routes.js'

import './styles/main.scss'

const app = createApp(App)

// import any used font awesome 5 icons here.
library.add(faPlus, faTimes, faEllipsisV, faBars, faMinusCircle, faSpinner, faExclamationTriangle, faSync, faPlay, faCheck, faPause, faEdit, faCaretUp, faCaretDown)

app.component('font-awesome-icon', FontAwesomeIcon)

app.component('toggle-button', ToggleButton)

if (config.SENTRY_API_URL) {
  Raven
    .config(`${config.SENTRY_API_URL}`, {
      environment: process.env.NODE_ENV
    })
    .addPlugin(RavenVue, app)
    .install()
}

app.use(Buefy, {
  defaultIconComponent: 'font-awesome-icon',
  defaultIconPack: 'fas',
})
app.use(VueSimpleAlert)


const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ top: 0 }),
  routes
})
app.use(router)

app.mount('#app')
